/**
 * Process JSON for next node on tracer action plan and create messages
 * @param {Array} walletData - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processKYCWalletProfile = (walletData, input, uploadedImages) => {
  const labels = walletData[0].data.searchedAddress.labels;
  const counterparty = walletData[0].data.counterPartySummary;

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:
      
      Analyze this Blockscope Wallet Profile data and provide a KYC report.
  
      Detailed label data:
      ${JSON.stringify(labels, null, 2)}

      Detailed counterparty data:
      ${JSON.stringify(counterparty, null, 2)}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};

